import { render, staticRenderFns } from "./ImageSectionInteractiveVoiceText.vue?vue&type=template&id=7b948f96&"
import script from "./ImageSectionInteractiveVoiceText.vue?vue&type=script&lang=js&"
export * from "./ImageSectionInteractiveVoiceText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports